'use strict';

exports.__esModule = true;
exports.default = deepValue;
function deepValue(obj, path) {
  for (var i = 0, spath = path.split('.'), len = spath.length; i < len; i++) {
    if (obj === undefined) {
      return obj;
    }
    obj = obj[spath[i]];
  }
  return obj;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-refetch/lib/utils/deepValue.js
 ** module id = 543
 ** module chunks = 0
 **/